import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ProductExportConfigurationContext } from '../../../../../../../../context/ProductExportConfigurationContext';
import DeleteModal from '../../../../../../../../VentoryUI/components/common/Modal/DeleteModal';
import { useRequest } from '../../../../../../../../requests/common/requestHook';
import { ProductExportConfigurationRequest } from '../../../../../../../../requests/productExportConfiguration.request';
import { translate } from '../../../../../../../../types/translation/Translator';
import { TranslationKey } from '../../../../../../../../types/translation/TranslationKey';
import { Routing } from '../../../../../../../../util/routes.util';
import {
  DeleteProductExportConfigurationInput,
  ProductExportConfigurationInput,
} from '../../../../../../../../types/product_export_configuration';

interface DeleteProductExportConfigurationModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  ids: Set<string>;
}

export default function DeleteProductExportConfigurationModal({
  open,
  setOpen,
  ids,
}: DeleteProductExportConfigurationModalProps) {
  const navigate = useNavigate();

  const { productExportConfigurations, setProductExportConfigurations } = useContext(ProductExportConfigurationContext);

  const [remove, { loading }] = useRequest(ProductExportConfigurationRequest.remove);

  const handleDelete = async () => {
    const toDelete: DeleteProductExportConfigurationInput[] = [];

    for (const id of ids) {
      const config = productExportConfigurations.get(id);
      if (config) toDelete.push(new ProductExportConfigurationInput(config).forDelete());
    }

    const result = await remove({ data: toDelete });
    if (!result) return;

    for (const config of result) {
      productExportConfigurations.delete(config.id);
    }

    setProductExportConfigurations(new Map(productExportConfigurations));
    handleClose();
    navigate(Routing.stock.products.settings.report.overview());
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <DeleteModal
      text={translate({ key: TranslationKey.productExportConfigurationDeleteConfirmationText })}
      onConfirm={handleDelete}
      open={open}
      onClose={handleClose}
      loading={loading}
    />
  );
}
